//++ core/footer ++//

  // Now, return the wrapped object if available.
  return ourself(false);

}));

//-- core/footer --//
